module.exports = __webpack_public_path__ + "static/media/smartphone-blue.c67d519e.svg";